import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;

  width: 100%;
  height: 100%;
`;

export const Graphic = styled.div`
  flex: 1;
  box-sizing: border-box;
`;

export const Sidebar = styled(Form)`
  margin-left: 1rem;

  display: flex;
  align-items: center;
  flex-direction: column;

  padding: 1rem;

  box-sizing: border-box;

  > div,
  > button {
    margin-top: 1rem;
  }
`;
